<nb-card>
  <nb-card-header>
    <button
      class="close"
      nbButton
      status="danger"
      size="small"
      (click)="close()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body [nbSpinner]="loading" nbSpinnerStatus="info">
    <h6 *ngIf="!receipt">Không tìm thấy dữ liệu</h6>
    <ngx-view-receipt
      *ngIf="receipt"
      [shopId]="shopId"
      [shop]="shop"
      [receipt]="receipt"
      [mode]="'detail'"
      (onClosed)="close()"
      (onDelete)="onDelete($event)"
    >
    </ngx-view-receipt>
  </nb-card-body>
</nb-card>
